
import { Component, Watch, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import { getOperateLog } from "@/api/api-operatelog.ts";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import {
  getSettlementOrderPage,
  getSettlementOrderAudit
} from "@/api/api-order-service";
// import { objAny, objStr, objNumber } from "../../common/common-interface";
import { getOptionList, optionKey } from "@/api/api-dict";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectTableData
  }
})
export default class SystemConfigLog extends mixins(tableMaxHeight) {
  @Prop({ default: "" }) private tabName!: string;
  @Prop({ default: "" }) private activeTab!: string;
  private privilegeVoObj: objAny = {};

  private time: objAny = {};
  private month: objAny = {};
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    createDateStr: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    oprPkId: "",
    orderStatus: "",
    // settleDateStr: "",
    settleOrderNo: ""
  };
  private ruleInline = {
    remark: [
      {
        required: true,
        trigger: "blur",
        message: i18n.t("splitSettlement.remarkPl")
      }
    ]
  };
  private createDateStr: object[] = [];
  // private settleDateStr = "";
  private orderStatusTodayList: object[] = [
    // { label: "待审核", value: 1 },
    // { label: "已结算", value: 2 },
    // { label: "已作废", value: 3 }
  ];
  private tableList: object[] = [];
  private tableColumns: object[] = [];
  private searchShow = true;

  private allTableData: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("splitSettlement.daySettlementOrderNumber"),
      key: "settleOrderNo",
      minWidth: 210
    },
    {
      title: i18n.t("splitSettlement.settlementDate"),
      key: "settlementDate",
      minWidth: 140
    },
    {
      title: i18n.t("splitSettlement.numberOfOrders"),
      key: "totalOrderCount",
      minWidth: 130
    },
    {
      title: i18n.t("splitSettlement.chargeVolume"),
      key: "totalChargeElect",
      minWidth: 130
    },
    {
      title: i18n.t("splitSettlement.chargeableAmount"),
      key: "totalAmount",
      minWidth: 145
    },
    {
      title: i18n.t("splitSettlement.discountAmount"),
      key: "totalDiscountAmount",
      minWidth: 130
    },
    {
      title: i18n.t("splitSettlement.actualChargeAmount"),
      key: "totalTransactionAmount",
      minWidth: 160
    },
    {
      title: i18n.t("splitSettlement.merchantIncomeAmount"),
      key: "totalMerchantIncome",
      minWidth: 185
    },
    {
      title: i18n.t("splitSettlement.operatorShareAmount"),
      key: "totalOprIncome",
      minWidth: 180
    },
    {
      title: i18n.t("splitSettlement.createTime"),
      key: "createTime",
      minWidth: 180
    },
    {
      title: i18n.t("splitSettlement.dailyStatementStatus"),
      key: "orderStatusDesc",
      minWidth: 200,
      slot: "orderStatusDesc"
    }
    // {
    //   title: i18n.t("operation"),
    //   slot: "action",
    //   width: 180,
    //   align: "center"
    // }
  ];
  private orderNos: object[] = [];
  private cancelModalShow = false;
  private errorForm: objAny = {
    remark: ""
  };
  private remark = "";
  // private timeFnMonthTime(val: objAny): void {
  //   if (val) {
  //     this.formInline.settleDateStr = val + "~" + val;
  //     // this.settleDateStr = this.formInline.settleDateStr;
  //   } else {
  //     this.formInline.settleDateStr = "";
  //   }
  // }

  private timeFnCreateDate(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      const startTime = this.$common.userDate(val[0], "yyyy-MM-dd");
      const endTime = this.$common.userDate(val[1], "yyyy-MM-dd");
      this.createDateStr = [startTime, endTime];
      this.formInline.createDateStr = startTime + "~" + endTime;
    } else {
      this.formInline.createDateStr = "";
    }
  }

  public queryClick(): void {
    if (!this.formInline.createDateStr) {
      this.$Message.error(i18n.t("formText.timeNull"));
      return;
    }
    // if (!this.formInline.settleDateStr) {
    //   this.$Message.error("月结月份不可以为空");
    //   return;
    // }

    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getSettlementOrderPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
      ret.data.map((item: objAny) => {
        if (item.orderStatus != 2) {
          // 只有没被审核的才允许审核或者作废的勾选  许老板说的20201111下午三点16分
          item._disabled = true;
        }
      });
    }
    this.loading = false;
  }
  public init(newVal: string): void {
    if (newVal === this.tabName && this.tableList.length === 0) {
      this.getTableList();
    }
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  public selectItem(list: object[]): void {
    const orderNos: object[] = [];

    list.map((item: objAny) => {
      orderNos.push(item.settleOrderNo);
    });
    this.orderNos = orderNos;
  }
  // 审核
  public handleAuditSuccess(item: objAny) {
    if (item.settleOrderNo) {
      const list = [];
      list.push(item.settleOrderNo);
      this.orderNos = list;
      this.$Modal.confirm({
        title: i18n.t("splitSettlement.auditOrder") + "",
        content: i18n.t("splitSettlement.auditOrderConfirm") + "",
        onOk: () => {
          this.getSettlementOrderAudit(1);
          this.orderNos = [];
        }
      });
    } else {
      if (this.orderNos.length != 0) {
        this.$Modal.confirm({
          title: i18n.t("splitSettlement.auditOrder") + "",
          content: i18n.t("splitSettlement.auditOrderConfirm") + "",
          onOk: () => {
            this.getSettlementOrderAudit(1);
            this.orderNos = [];
          }
        });
      } else {
        this.$Message.error(i18n.t("splitSettlement.auditOrderPl"));
      }
    }
  }
  // 作废
  public handleAuditCancel(item: objAny) {
    if (item.settleOrderNo) {
      const list = [];
      list.push(item.settleOrderNo);
      this.orderNos = list;
      this.cancelModalShow = true;
    } else {
      if (this.orderNos.length == 0) {
        this.$Message.error(i18n.t("splitSettlement.voidPl"));
        // } else {
        //   this.getSettlementOrderAudit(2);
      } else {
        this.cancelModalShow = true;
      }
    }
  }

  // 作废原因之后操作作废
  public handleRefuseTrue() {
    this.getSettlementOrderAudit(2);
  }

  async getSettlementOrderAudit(type: number) {
    const ret = await getSettlementOrderAudit({
      action: type,
      orderNos: this.orderNos,
      remark: type == 2 ? this.remark : ""
    });
    if (ret.status === this.$config.apiStatus) {
      if (type == 2) {
        this.$Message.success(i18n.t("splitSettlement.voidSuccess"));
        this.cancelModalShow = false;
        this.remark = "";
        this.orderNos = [];
        this.getTableList();
      } else {
        this.$Message.success(i18n.t("splitSettlement.auditOrderSuccess"));
        this.remark = "";
        this.orderNos = [];
        this.getTableList();
      }
    }
  }
  @Watch("activeTab")
  getVisible2(newVal: string) {
    this.init(newVal);
  }

  async getTypeList() {
    const ret = await getOptionList([optionKey.orderStatusTodayList]); //请求字典
    this.orderStatusTodayList = ret[optionKey.orderStatusTodayList]; // 发票类型
  }
  public handAddSubmit() {
    const formInlineError: objAny = this.$refs["formInlineError"] || {};
    formInlineError.validate((valid: boolean) => {
      if (valid) {
        this.getSettlementOrderAudit(2);
      }
    });
  }
  mounted() {
    const query = this.$route.query;
    if (query.orderStatus) {
      this.formInline.orderStatus = query.orderStatus;
    }
    this.getTypeList();
    const month = this.$common.thisTimes("yyyy-MM");
    const endTime = this.$common.thisTimes("yyyy-MM-dd");
    const startTime = month + "-01";

    this.createDateStr = [startTime, endTime];
    this.formInline.createDateStr = startTime + "~" + endTime;

    this.init(this.activeTab);
    this.getTableList();
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
  }
}
